import BlogCard from "./blog-card";
import type { BlogPost } from "~/models/blogPost";
import { useLoaderData } from "react-router";

export default function LatestBlogsSection() {
    const { blogPosts } = useLoaderData<{ blogPosts: BlogPost[] | null }>();
    
    // Don't render if no blog posts
    if (!blogPosts || blogPosts.length === 0) return null;

    return (
        <section id="latest-blogs" className="courses">
            <div className="container" data-aos="fade-up">
                <div className="section-title">
                    <h2>Blog</h2>
                    <p>Featured Blog Posts</p>
                </div>
                
                <div className="row" data-aos="zoom-in" data-aos-delay="100">
                    {blogPosts.map((post) => (
                        <div className="col-lg-4 col-md-6 d-flex align-items-stretch mb-4" key={post.id}>
                            <BlogCard post={post} />
                        </div>
                    ))}
                </div>

                <div className="text-center mt-4" data-aos="fade-up" data-aos-delay="200">
                    <a 
                        href="https://blog.constellationtraining.co.uk" 
                        className="btn btn-primary"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        View All Blog Posts
                    </a>
                </div>
            </div>
        </section>
    );
}
